const LargeGrid = ({ width }) => {
    return (
        <div className={`large-grid-icon ${width}`}>
                <svg
              xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
              fill="none"
              viewBox="0 0 16 16"
            >
              <path fill="#414042" d="M0 0H7V7H0z"></path>
              <path fill="#414042" d="M9 0h7v7H9V0z"></path>
              <path fill="#414042" d="M9 9H16V16H9z"></path>
              <path fill="#414042" d="M0 9H7V16H0z"></path>
            </svg>
        </div>
    )
}

export default LargeGrid
